import {z} from "zod/v4-mini"
import {ImageOpNode} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"

export const definition = {
    validation: {
        returns: z.any(),
        parameters: z.object({
            key: z.string(),
            value: z.instanceof(ImageOpNode),
        }),
    },
}
